import axios from "axios";
import { getSiteIdentifier, getFloorIdentifier } from './util.js';


export const AUTH_FAILED = 'Authentication Failed';
export const NOT_FOUND = '404 - Notfound';
export const UNKNOWN = 'UNKNOWN';


function getRedirectUrl(){
    let siteIdentifier;
    let floorIdentifier;
    try {
        siteIdentifier = getSiteIdentifier();
    }
    catch(err) {
        console.log(err);
    } 
    try {
        floorIdentifier = getFloorIdentifier();
    }
    catch(err) {
        console.log(err);
    } 
    return SERVICE_URL+DASHBOARD_URL + encodeURIComponent(HOST+'/?siteIdentifier='+siteIdentifier+'&floorIdentifier='+floorIdentifier);
};

const axiosInstance = axios.create({
  baseURL: SERVICE_URL,
  timeout: 5000,
  withCredentials: true
});


axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if(error.response && error.response.status){
      if(error.response.status == 401){
        window.location.replace(getRedirectUrl());
      }
    }
    return Promise.reject(error.response);
  }
);



export { axiosInstance };